import { useMemo } from "react";
import { AutovioCalendarEvent } from "../model/autovioCalendarEvents";
import { useNegativeBalanceWarnings } from "./useNegativeBalanceWarnings";
import { useMissingVehiclesWarnings } from "./useMissingVehiclesWarnings";

export function useDrivingSchoolExamsCalendarWarnings(events: undefined | AutovioCalendarEvent[]): {
  warningsByDay: Map</* "yyyy-MM-dd" */ string, Array<string>>;
  warningsByEventId: Map<string, Array<string>>;
} {
  const missingVehiclesWarnings = useMissingVehiclesWarnings(events);
  const negativeBalanceWarnings = useNegativeBalanceWarnings(events);
  const result = useMemo(() => {
    const warningsByDay = new Map<string, Array<string>>();
    for (const [day, warning] of missingVehiclesWarnings.warningsByDay.entries()) {
      warningsByDay.set(day, [warning]);
    }
    for (const [day, warning] of negativeBalanceWarnings.warningsByDay.entries()) {
      const warnings = warningsByDay.get(day) ?? [];
      warnings.push(warning);
      warningsByDay.set(day, warnings);
    }
    const warningsByEventId = new Map<string, Array<string>>();
    for (const [eventId, warnings] of missingVehiclesWarnings.warningsByEventId.entries()) {
      warningsByEventId.set(eventId, warnings);
    }
    for (const [eventId, warning] of negativeBalanceWarnings.warningsByEventId.entries()) {
      warningsByEventId.set(eventId, [...(warningsByEventId.get(eventId) ?? []), warning]);
    }
    return { warningsByDay, warningsByEventId };
  }, [missingVehiclesWarnings, negativeBalanceWarnings]);
  return result;
}
